import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import {
  Input,
  SubmitButton,
  SubTab,
  SubInput,
  RenderInputFields,
} from "../Form/Form";

import { createSlug } from "../../util/fn";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm();

  const history = useHistory();

  const { languages } = useSelector((state) => state.setting);

  const { response, request } = useRequest();

  useEffect(() => {
    document.title = "Add Country";
  }, []);

  useEffect(() => {
    if (response) {
      console.log("response", response);
      toast.success("Country added successfully.");
      history.push("/countries");
    }
  }, [response]);

  const onSubmit = (data) => {
    const dataToSend = [];
    const checkData = {
      label: "",
      value: "",
      langData: [],
    };

    let name, countryCode;

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      dataToSend.push({
        languageCode: code,
        name: data["name-" + code] ?? "",
        countryCode: data.countryCode,
      });

      if (languages[i].default) {
        name = data["name-" + code];
        countryCode = data.countryCode;
        checkData.label = name;
        checkData.value = name;
      }

      checkData.langData.push({
        languageCode: code,
        value: data["name-" + code] ?? "",
        countryCode: data.countryCode,
      });
    }

    request("POST", "country/create", {
      name,
      countryCode,
      subData: dataToSend,
    });
  };

  const InputFields = [
    [
      {
        Component: Input,
        label: "Country Code",
        type: "number",
        name: "countryCode",
        registerFields: {
          required: true,
        },
      },
    ],
  ];

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Add Country"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/countries", name: "Back To Countries" },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div className="card-header">
              <h3 className="card-title">Add New Country</h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="card card-custom gutter-b">
                      <RenderInputFields
                        InputFields={InputFields}
                        errors={errors}
                        register={register}
                      />

                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                  tabName={`language_${index}`}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>

                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <SubInput
                                key={index}
                                index={index}
                                errors={errors}
                                register={register}
                                required={lang.required}
                                control={control}
                                code={lang.code}
                                tabName={`language_${index}`}
                                InputFields={[
                                  [
                                    {
                                      Component: Input,
                                      label: "Name",
                                      type: "text",
                                      name: "name",
                                      isRequired: true,
                                      colClass: " ",
                                      registerFields: {
                                        onBlur: (e) => {
                                          setValue(
                                            `slug-${lang.code}`,
                                            createSlug(e.target.value)
                                          );
                                        },
                                      },
                                    },
                                  ],
                                ]}
                              />
                            ))}
                        </div>
                      </div>
                    </div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                      pxClass="px-10"
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
